import settings from './settings.yaml'
import stage from './stage.yaml'

export default {
  settings,
  stage,
}
